import React, { useState, useEffect } from 'react';
import api from '../../services/api';

const ScigovTab = () => {
  // Scigov state
  const [scigovSettings, setScigovSettings] = useState([]);
  const [scigovLoading, setScigovLoading] = useState(false);
  const [showScigovSettingForm, setShowScigovSettingForm] = useState(false);
  const [newScigovSetting, setNewScigovSetting] = useState({
    partyName: '',
    startYear: new Date().getFullYear(),
    endYear: new Date().getFullYear() + 1,
    status: ''
  });
  const [scigovFormErrors, setScigovFormErrors] = useState({});
  const [scigovSubmitting, setScigovSubmitting] = useState(false);
  const [editingScigovSetting, setEditingScigovSetting] = useState(null);
  const [showScigovEditForm, setShowScigovEditForm] = useState(false);

  // Scigov number settings state
  const [scigovNumberSettings, setScigovNumberSettings] = useState([]);
  const [scigovNumberLoading, setScigovNumberLoading] = useState(false);
  const [showScigovNumberForm, setShowScigovNumberForm] = useState(false);
  const [newScigovNumberSetting, setNewScigovNumberSetting] = useState({
    scraperType: 'scigov',
    cnr_number: ''
  });
  const [scigovNumberErrors, setScigovNumberErrors] = useState({});
  const [scigovNumberSubmitting, setScigovNumberSubmitting] = useState(false);

  // Scigov scrape results state
  const [scigovScrapeResults, setScigovScrapeResults] = useState([]);
  const [scigovScrapeLoading, setScigovScrapeLoading] = useState(false);
  const [scigovSearchKeyword, setScigovSearchKeyword] = useState('');
  const [scigovSearchResults, setScigovSearchResults] = useState([]);
  const [scigovSearchLoading, setScigovSearchLoading] = useState(false);
  const [scigovPagination, setScigovPagination] = useState({
    total: 0,
    limit: 50,
    skip: 0,
    hasMore: false
  });

  // Scigov status options
  const scigovStatusOptions = [
    { value: 'P', label: 'Pending' },
    { value: 'D', label: 'Disposed' }
  ];

  // Load initial Scigov scrape results
  useEffect(() => {
    searchScigovScrapeResults('', 0);
  }, []);

  // API functions for Scigov settings CRUD operations
  const addScigovSetting = async (settingData) => {
    try {
      const response = await api.post('http://45.32.210.228:3000/api/scigov/settings/add', settingData);
      return response.data;
    } catch (error) {
      console.error('Error adding scigov setting:', error);
      return { success: false, message: error.response?.data?.message || 'Failed to add setting' };
    }
  };

  const updateScigovSetting = async (settingId, settingData) => {
    try {
      const response = await api.put(`http://45.32.210.228:3000/api/scigov/settings/${settingId}`, settingData);
      return response.data;
    } catch (error) {
      console.error('Error updating scigov setting:', error);
      return { success: false, message: error.response?.data?.message || 'Failed to update setting' };
    }
  };

  const deleteScigovSetting = async (settingId) => {
    try {
      const response = await api.delete(`http://45.32.210.228:3000/api/scigov/settings/${settingId}`);
      if (response.data.success) {
        console.log('Scigov setting deleted successfully');
        return { success: true };
      } else {
        return { success: false, message: response.data.message || 'Failed to delete setting' };
      }
    } catch (error) {
      console.error('Error deleting scigov setting:', error);
      return { success: false, message: error.response?.data?.message || 'Error deleting scigov setting' };
    }
  };

  const fetchScigovSettings = async () => {
    try {
      setScigovLoading(true);
      const response = await api.get('http://45.32.210.228:3000/api/scigov/settings/load');
      if (response.data.success) {
        setScigovSettings(response.data.settings.settings || []);
      }
    } catch (error) {
      console.error('Error fetching scigov settings:', error);
    } finally {
      setScigovLoading(false);
    }
  };

  const fetchScigovNumberSettings = async () => {
    try {
      setScigovNumberLoading(true);
      const response = await api.get('http://45.32.210.228:3000/api/number-settings?scraperType=scigov');
      if (response.data.success) {
        setScigovNumberSettings(response.data.data.settings || []);
      }
    } catch (error) {
      console.error('Error fetching scigov number settings:', error);
    } finally {
      setScigovNumberLoading(false);
    }
  };

  const addScigovNumberSetting = async (settingData) => {
    try {
      setScigovNumberSubmitting(true);
      const response = await api.post('http://45.32.210.228:3000/api/number-settings/add', settingData);
      if (response.data.success) {
        console.log('Scigov number setting added successfully');
        return { success: true };
      } else {
        return { success: false, message: response.data.message || 'Failed to add scigov number setting' };
      }
    } catch (error) {
      console.error('Error adding scigov number setting:', error);
      return { success: false, message: error.response?.data?.message || 'Error adding scigov number setting' };
    } finally {
      setScigovNumberSubmitting(false);
    }
  };

  const deleteScigovNumberSetting = async (settingId) => {
    try {
      const response = await api.delete(`http://45.32.210.228:3000/api/number-settings/scigov/id/${settingId}`);
      if (response.data.success) {
        console.log('Scigov number setting deleted successfully');
        return { success: true };
      } else {
        return { success: false, message: response.data.message || 'Failed to delete scigov number setting' };
      }
    } catch (error) {
      console.error('Error deleting scigov number setting:', error);
      return { success: false, message: error.response?.data?.message || 'Error deleting scigov number setting' };
    }
  };

  const searchScigovScrapeResults = async (keyword, skip = 0) => {
    try {
      setScigovScrapeLoading(true);
      const response = await api.get(`http://45.32.210.228:3000/api/results/search?scraperType=scigov&keywords=${keyword}&skip=${skip}&limit=50`);
      if (response.data.success) {
        if (skip === 0) {
          setScigovScrapeResults(response.data.data.results || []);
        } else {
          setScigovScrapeResults(prev => [...prev, ...(response.data.data.results || [])]);
        }
        setScigovPagination({
          total: response.data.data.total || 0,
          limit: 50,
          skip: skip + 50,
          hasMore: (response.data.data.results || []).length === 50
        });
      }
    } catch (error) {
      console.error('Error searching scigov scrape results:', error);
    } finally {
      setScigovScrapeLoading(false);
    }
  };

  // Scigov form handlers
  const handleAddScigovSetting = async (e) => {
    e.preventDefault();
    
    const settingData = {
      partyName: newScigovSetting.partyName,
      startYear: parseInt(newScigovSetting.startYear),
      endYear: parseInt(newScigovSetting.endYear),
      status: newScigovSetting.status
    };

    const errors = validateScigovForm(settingData);
    if (Object.keys(errors).length > 0) {
      setScigovFormErrors(errors);
      return;
    }

    const result = await addScigovSetting(settingData);
    if (result.success) {
      // Reset form
      setNewScigovSetting({
        partyName: '',
        startYear: new Date().getFullYear(),
        endYear: new Date().getFullYear() + 1,
        status: ''
      });
      setScigovFormErrors({});
      setShowScigovSettingForm(false);
      
      // Refresh settings list
      fetchScigovSettings();
      
      // Show success message
      alert('Scigov setting added successfully!');
    } else {
      alert(`Error: ${result.message}`);
    }
  };

  const handleEditScigovSetting = async (e) => {
    e.preventDefault();
    
    const settingData = {
      partyName: editingScigovSetting.partyName,
      startYear: parseInt(editingScigovSetting.startYear),
      endYear: parseInt(editingScigovSetting.endYear),
      status: editingScigovSetting.status
    };

    const errors = validateScigovForm(settingData);
    if (Object.keys(errors).length > 0) {
      setScigovFormErrors(errors);
      return;
    }

    const result = await updateScigovSetting(editingScigovSetting.setting_id, settingData);
    if (result.success) {
      // Reset form
      setEditingScigovSetting(null);
      setScigovFormErrors({});
      setShowScigovEditForm(false);
      
      // Refresh settings list
      fetchScigovSettings();
      
      // Show success message
      alert('Scigov setting updated successfully!');
    } else {
      alert(`Error: ${result.message}`);
    }
  };

  const handleDeleteScigovSetting = async (settingId) => {
    if (window.confirm('Are you sure you want to delete this scigov setting?')) {
      const result = await deleteScigovSetting(settingId);
      if (result.success) {
        // Refresh settings list
        fetchScigovSettings();
        
        // Show success message
        alert('Scigov setting deleted successfully!');
      } else {
        alert(`Error: ${result.message}`);
      }
    }
  };

  const openScigovEditForm = (setting) => {
    console.log('Opening scigov edit form for setting:', setting);
    setEditingScigovSetting(setting);
    setShowScigovEditForm(true);
  };

  const handleAddScigovNumberSetting = async (e) => {
    e.preventDefault();
    
    if (!newScigovNumberSetting.cnr_number.trim()) {
      setScigovNumberErrors({ cnr_number: 'CNR Number is required' });
      return;
    }

    const result = await addScigovNumberSetting(newScigovNumberSetting);
    if (result.success) {
      // Reset form
      setNewScigovNumberSetting({
        scraperType: 'scigov',
        cnr_number: ''
      });
      setScigovNumberErrors({});
      setShowScigovNumberForm(false);
      
      // Refresh number settings list
      fetchScigovNumberSettings();
      
      // Show success message
      alert('Scigov number setting added successfully!');
    } else {
      alert(`Error: ${result.message}`);
    }
  };

  const handleDeleteScigovNumberSetting = async (settingId) => {
    if (window.confirm('Are you sure you want to delete this scigov number setting?')) {
      const result = await deleteScigovNumberSetting(settingId);
      if (result.success) {
        // Refresh number settings list
        fetchScigovNumberSettings();
        
        // Show success message
        alert('Scigov number setting deleted successfully!');
      } else {
        alert(`Error: ${result.message}`);
      }
    }
  };

  // Add CNR number from scrape result to scigov number settings
  const handleScigovAddToDetail = async (cnrNumber) => {
    if (!cnrNumber) {
      alert('No CNR number available for this result');
      return;
    }

    // Check if CNR number already exists
    const existingSetting = scigovNumberSettings.find(setting => setting.cnr_number === cnrNumber);
    if (existingSetting) {
      alert('This CNR number is already in your scigov number settings');
      return;
    }

    // Add the CNR number to scigov number settings
    const settingData = {
      scraperType: 'scigov',
      cnr_number: cnrNumber
    };

    const result = await addScigovNumberSetting(settingData);
    if (result.success) {
      // Refresh scigov number settings list
      fetchScigovNumberSettings();
      
      // Show success message
      alert(`CNR number ${cnrNumber} added to scigov number settings successfully!`);
    } else {
      alert(`Error: ${result.message}`);
    }
  };

  const validateScigovForm = (data) => {
    const errors = {};
    if (!data.partyName) {
      errors.partyName = 'Party Name is required';
    }
    if (!data.startYear || !data.endYear) {
      errors.yearRange = 'Start and end years are required';
    }
    if (data.startYear > data.endYear) {
      errors.yearRange = 'Start year cannot be greater than end year';
    }
    if (!data.status) {
      errors.status = 'Case Status is required';
    }
    return errors;
  };

  const handleScigovSearch = (e) => {
    e.preventDefault();
    searchScigovScrapeResults(scigovSearchKeyword, 0);
  };

  const handleScigovLoadMore = () => {
    searchScigovScrapeResults(scigovSearchKeyword, scigovPagination.skip);
  };

  // Load data when component mounts
  useEffect(() => {
    fetchScigovSettings();
    fetchScigovNumberSettings();
  }, []);

  // Scigov number results state
  const [scigovNumberResults, setScigovNumberResults] = useState([]);
  const [scigovNumberResultsLoading, setScigovNumberResultsLoading] = useState(false);

  // API function to fetch Scigov number results
  const fetchScigovNumberResults = async () => {
    try {
      setScigovNumberResultsLoading(true);
      const response = await api.get('http://45.32.210.228:3000/api/number-data/scigov-numbers');
      if (response.data.success) {
        // Ensure we have an array of results
        const results = response.data.data;
        if (Array.isArray(results)) {
          setScigovNumberResults(results);
        } else if (results && Array.isArray(results.results)) {
          setScigovNumberResults(results.results);
        } else {
          console.warn('Unexpected data structure for scigov number results:', results);
          setScigovNumberResults([]);
        }
      } else {
        setScigovNumberResults([]);
      }
    } catch (error) {
      console.error('Error fetching scigov number results:', error);
      setScigovNumberResults([]);
    } finally {
      setScigovNumberResultsLoading(false);
    }
  };

  // Load Scigov number results when component mounts
  useEffect(() => {
    fetchScigovNumberResults();
  }, []);

  // Function to extract petitioner and respondent information
  const extractScigovPartyInfo = (petitionerVsRespondent) => {
    if (!petitionerVsRespondent) return { petitioners: '', respondents: '' };
    
    const parts = petitionerVsRespondent.split(' vs. ');
    if (parts.length === 2) {
      return {
        petitioners: parts[0].trim(),
        respondents: parts[1].trim()
      };
    }
    return { petitioners: petitionerVsRespondent, respondents: '' };
  };

  // Function to extract advocate information from documents
  const extractScigovAdvocateInfo = (documents) => {
    if (!documents || !documents['OTHER DOCUMENT(s)']) return { petitionerAdvocates: '', respondentAdvocates: '' };
    
    const docs = documents['OTHER DOCUMENT(s)'];
    const petitionerAdvocates = [];
    const respondentAdvocates = [];
    
    docs.forEach(doc => {
      if (doc['Document Type'] === 'VAKALATNAMA AND MEMO OF APPEARANCE') {
        const filedBy = doc['Filed By'];
        if (filedBy) {
          petitionerAdvocates.push(filedBy);
        }
      }
    });
    
    return {
      petitionerAdvocates: petitionerAdvocates.join(', '),
      respondentAdvocates: respondentAdvocates.join(', ')
    };
  };

  const renderKeywordTab = () => (
    <div className="space-y-6">
      {/* Settings List */}
      <div className="bg-white rounded-lg shadow">
        <div className="px-6 py-4 border-b border-gray-200">
          <div className="flex justify-between items-center">
            <h3 className="text-lg font-medium text-gray-900">Scigov Settings</h3>
            <button
              onClick={() => setShowScigovSettingForm(true)}
              className="px-4 py-2 text-sm font-medium text-white bg-blue-600 border border-transparent rounded-md hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-blue-500"
            >
              Add Setting
            </button>
          </div>
        </div>
        
        <div className="p-6">
          {scigovLoading ? (
            <div className="text-center py-4">
              <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-blue-600 mx-auto"></div>
              <p className="mt-2 text-sm text-gray-600">Loading scigov settings...</p>
            </div>
          ) : scigovSettings.length === 0 ? (
            <p className="text-gray-500 text-center py-4">No scigov settings found</p>
          ) : (
            <div className="space-y-4">
              {scigovSettings.map((setting) => (
                <div key={setting.setting_id} className="border border-gray-200 rounded-lg p-4">
                  <div className="flex justify-between items-start">
                    <div className="flex-1">
                      <h4 className="font-medium text-gray-900">Party Name: {setting.partyName}</h4>
                      <p className="text-sm text-gray-600">Year Range: {setting.startYear} - {setting.endYear}</p>
                      <p className="text-sm text-gray-600">Status: {setting.status}</p>
                    </div>
                    <div className="flex space-x-2">
                      <button
                        onClick={() => openScigovEditForm(setting)}
                        className="px-3 py-1 text-sm text-blue-600 hover:text-blue-800"
                      >
                        Edit
                      </button>
                      <button
                        onClick={() => handleDeleteScigovSetting(setting.setting_id)}
                        className="px-3 py-1 text-sm text-red-600 hover:text-red-800"
                      >
                        Delete
                      </button>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          )}
        </div>
      </div>

      {/* Scrape Results */}
      <div className="bg-white rounded-lg shadow">
        <div className="px-6 py-4 border-b border-gray-200">
          <h3 className="text-lg font-medium text-gray-900">Scigov Scrape Results</h3>
        </div>
        
        <div className="p-6">
          <form onSubmit={handleScigovSearch} className="mb-4">
            <div className="flex space-x-2">
              <input
                type="text"
                value={scigovSearchKeyword}
                onChange={(e) => setScigovSearchKeyword(e.target.value)}
                placeholder="Search by keyword..."
                className="flex-1 px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
              />
              <button
                type="submit"
                disabled={scigovScrapeLoading}
                className="px-4 py-2 text-sm font-medium text-white bg-blue-600 border border-transparent rounded-md hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-blue-500 disabled:opacity-50"
              >
                {scigovScrapeLoading ? 'Searching...' : 'Search'}
              </button>
            </div>
          </form>

          {scigovScrapeLoading ? (
            <div className="text-center py-4">
              <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-blue-600 mx-auto"></div>
              <p className="mt-2 text-sm text-gray-600">Searching...</p>
            </div>
          ) : scigovScrapeResults.length === 0 ? (
            <p className="text-gray-500 text-center py-4">No results found</p>
          ) : (
            <div className="space-y-4">
              {scigovScrapeResults.map((result) => (
                <div key={result._id} className="border border-gray-200 rounded-lg p-4">
                  <h4 className="font-medium text-gray-900">Case Number: {result.caseNumber || '-'}</h4>
                  <p className="text-sm text-gray-600">CNR: {result.cnr_number || '-'}</p>
                  <p className="text-sm text-gray-600">Petitioner Name: {result.petitionerName || '-'}</p>
                  <p className="text-sm text-gray-600">Respondent Name: {result.respondentName || '-'}</p>
                  <p className="text-sm text-gray-600">Status: {result.status || '-'}</p>
                  <div className="flex space-x-2 mt-2">
                    <button
                      onClick={() => handleScigovAddToDetail(result.cnr_number)}
                      className="px-3 py-1 text-sm text-green-600 hover:text-green-800"
                    >
                      Add to Detail
                    </button>
                  </div>
                </div>
              ))}
              
              {scigovPagination.hasMore && (
                <div className="text-center pt-4">
                  <button
                    onClick={handleScigovLoadMore}
                    disabled={scigovScrapeLoading}
                    className="px-4 py-2 text-sm font-medium text-blue-600 bg-blue-50 border border-blue-200 rounded-md hover:bg-blue-100 focus:outline-none focus:ring-2 focus:ring-blue-500 disabled:opacity-50"
                  >
                    Load More
                  </button>
                </div>
              )}
            </div>
          )}
        </div>
      </div>
    </div>
  );

  const renderNumberTab = () => (
    <div className="space-y-6">
      {/* Number Settings */}
      <div className="bg-white rounded-lg shadow">
        <div className="px-6 py-4 border-b border-gray-200">
          <div className="flex justify-between items-center">
            <h3 className="text-lg font-medium text-gray-900">Scigov CNR Number Settings</h3>
            <button
              onClick={() => setShowScigovNumberForm(true)}
              className="px-4 py-2 text-sm font-medium text-white bg-blue-600 border border-transparent rounded-md hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-blue-500"
            >
              Add CNR Number
            </button>
          </div>
        </div>
        
        <div className="p-6">
          {scigovNumberLoading ? (
            <div className="text-center py-4">
              <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-blue-600 mx-auto"></div>
              <p className="mt-2 text-sm text-gray-600">Loading scigov number settings...</p>
            </div>
          ) : scigovNumberSettings.length === 0 ? (
            <p className="text-gray-500 text-center py-4">No scigov number settings found</p>
          ) : (
            <div className="space-y-4">
              {scigovNumberSettings.map((setting) => (
                <div key={setting._id} className="border border-gray-200 rounded-lg p-4">
                  <div className="flex justify-between items-center">
                    <div>
                      <h4 className="font-medium text-gray-900">CNR Number: {setting.cnr_number}</h4>
                    </div>
                    <button
                      onClick={() => handleDeleteScigovNumberSetting(setting._id)}
                      className="px-3 py-1 text-sm text-red-600 hover:text-red-800"
                    >
                      Delete
                    </button>
                  </div>
                </div>
              ))}
            </div>
          )}
        </div>
      </div>

      {/* Number Results Table */}
      <div className="bg-white rounded-lg shadow">
        <div className="px-6 py-4 border-b border-gray-200">
          <h3 className="text-lg font-medium text-gray-900">Scigov Number Results</h3>
        </div>
        
        <div className="p-6">
          {scigovNumberResultsLoading ? (
            <div className="text-center py-4">
              <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-blue-600 mx-auto"></div>
              <p className="mt-2 text-sm text-gray-600">Loading scigov number results...</p>
            </div>
          ) : (Array.isArray(scigovNumberResults) ? scigovNumberResults : []).length === 0 ? (
            <p className="text-gray-500 text-center py-4">No scigov number results found</p>
          ) : (
            <div className="space-y-4">
              {(Array.isArray(scigovNumberResults) ? scigovNumberResults : []).map((result, index) => (
                <div key={index} className="border border-gray-200 rounded-lg p-4">
                  <h4 className="font-medium text-gray-900">CNR Number: {result.cnr_number || '-'}</h4>
                  <p className="text-sm text-gray-600">Status/Stage: {result["Status/Stage"] || '-'}</p>
                  <p className="text-sm text-gray-600">Petitioner Advocate(s): {result["Petitioner Advocate(s)"] || '-'}</p>
                  <p className="text-sm text-gray-600">Respondent Advocate(s): {result["Respondent Advocate(s)"] || '-'}</p>
                </div>
              ))}
            </div>
          )}
        </div>
      </div>
    </div>
  );

  return {
    renderKeywordTab,
    renderNumberTab,
    showScigovSettingForm,
    setShowScigovSettingForm,
    showScigovEditForm,
    setShowScigovEditForm,
    showScigovNumberForm,
    setShowScigovNumberForm,
    newScigovSetting,
    setNewScigovSetting,
    editingScigovSetting,
    setEditingScigovSetting,
    newScigovNumberSetting,
    setNewScigovNumberSetting,
    scigovFormErrors,
    setScigovFormErrors,
    scigovNumberErrors,
    setScigovNumberErrors,
    scigovSubmitting,
    setScigovSubmitting,
    scigovNumberSubmitting,
    setScigovNumberSubmitting,
    scigovStatusOptions,
    handleAddScigovSetting,
    handleEditScigovSetting,
    handleAddScigovNumberSetting,
    handleScigovAddToDetail,
    fetchScigovNumberResults
  };
};

export default ScigovTab; 